// clearance-form-svg.js

// SVG rendering functions for the input form
// Handles lazy-loading and switching of SVG views per unit

// The diagram view at the top of the unit pane allows for selecting different views
// and loading the SVG dynamically to avoid initial load bloat
// unit side, combination side, combination top views.

//
// Combination SVG rendering
//
const renderCombinationUri = '/api/render-clearance-svg';

// Track which views have been rendered to avoid repeat API calls

const renderedViews = new Set(); // const viewKey = `${unitIndex}|${viewMode}`;

// Clears SVG content either for a specific viewKey or all views
export function clearCombinationSVG(viewKey = null) {
   if (viewKey) {
      // Parse unitIndex and viewMode from viewKey (format: "unitIndex-viewMode")
      const [unitIndex, viewMode] = viewKey.split('|');
      if (!unitIndex || !viewMode) {
         console.warn(`Invalid viewKey format: ${viewKey}`);
         return;
      }
      const containerId = getSvgContainerId(unitIndex, viewMode);

      $(`#${containerId}`).empty();
      renderedViews.delete(viewKey);
   } else {
      // Clear all rendered SVG views
      $('.view-pane').empty();
      renderedViews.clear();
   }
}

export function updateCombinationSVG(unitIndex, viewMode, formValues, forceClear) {
   const svgId = getSvgContainerId(unitIndex, viewMode);
   const viewKey = `${unitIndex}|${viewMode}`;
   if (forceClear) clearCombinationSVG(viewKey); // if force clear is true, clear the cached SVG first
   if (!renderedViews.has(viewKey)) {
      fetchCombinationSvg(viewMode, formValues, (svgFrame) => {
         if (svgFrame == null || !Array.isArray(svgFrame)) {
            return;
         }
         //const svgView = svgFrame[0].view;
         const svgHtml = svgFrame[0].svg;
         if (svgHtml) {
            $(`#${svgId}`).html(svgHtml);
            renderedViews.add(viewKey);
         } else {
            console.error(`No SVG found for view ${view} in unit ${unitIndex}`);
         }
      });
   }
}

function fetchCombinationSvg(viewMode, formValues, callback) {
   const views = [getView(viewMode)];
   const fixedWorldBounds = getFixedWorldBounds(formValues, true); // use total length for combination
   const options = {
      scaleMode: 'fixed-scale',
      margin: 10, // margin in px
      scalePxPerMetre: 50,
      fixedWorldBounds,
   };

   const data = {
      views,
      options,
      formValues,
   };

   $.ajax({
      url: renderCombinationUri,
      method: 'POST',
      contentType: 'application/json',
      data: JSON.stringify(data),
      success: function (svgFrame) {
         callback(svgFrame);
      },
      error: function (xhr, status, error) {
         console.error('SVG diagram generation failed for combination:', status, error);
      },
   });
}

//
// Unit SVG rendering
//
const renderUnitUri = '/api/render-clearance-unit-svg';

export function updateUnitSideSVG(unitIndex, formValues) {
   fetchUnitSideSvg(unitIndex, formValues, (svgHtml) => {
      if (svgHtml) {
         $(`#unit-diagram-svg-${unitIndex}`).empty().html(svg);
      } else {
         console.error(`No SVG received for unit ${unitIndex}`);
      }
   });
}

function fetchUnitSideSvg(unitIndex, formValues, callback) {
   const unit = formValues.units[unitIndex];
   if (!unit) return;

   const fixedWorldBounds = getFixedWorldBounds(formValues, false);
   const options = {
      scaleMode: 'fixed-scale', // use consistent px/m across units
      scalePxPerMetre: 50, // fixed horizontal/vertical scale
      fixedWorldBounds,
      margin: 50, // margin in px, allowance for labels, outside of the unit
      showAxes: false,
      showSegmentBase: true,
      showDimensions: true,
      shortLabels: false,
      useValues: true, // use values for dimensions
      centerX: true, // center the unit on X axis
      centerY: true, // center the unit on Y axis
   };

   const data = {
      unit,
      options,
      view: 'side', // always render side view for unit diagrams
   };

   $.ajax({
      url: `${renderUnitUri}?v=${Date.now()}`, //  Add a unique param to bust cache
      method: 'POST',
      contentType: 'application/json',
      data: JSON.stringify(data),
      success: (svg) => {
         $(`#unit-diagram-svg-${unitIndex}`).empty().html(svg);
      },
      error: (xhr) => {
         console.error('Failed to render unit diagram:', xhr.responseText);
      },
   });
}

//
// Utility functions
//

/**
 * Estimate real-world bounding box of the full vehicle combination.
 * @param {Object} formValues - Vehicle combination object with unit array
 * @returns {Object} fixedWorldBounds { x: [min, max], y: [min, max], z: [min, max] }
 */
function getFixedWorldBounds(formValues, useLength = false) {
   if (!formValues || !Array.isArray(formValues.units)) {
      throw new Error('Invalid formValues structure');
   }
   const { min, max, totalXLength } = minMaxXBounds(formValues.units);
   const { maxBodyHeight, maxBodyWidth } = maxWidthHeight(formValues.units); // this updates maxY and maxWidth
   const maxX = useLength ? totalXLength : max;
   const bounds = {
      x: [min, maxX], // use the min X from all units and total length of combination
      y: [0, maxBodyHeight],
      z: [-maxBodyWidth / 2, maxBodyWidth / 2],
   };

   return bounds;
}

// Determine which container ID to load into
function getSvgContainerId(unitIndex, viewMode) {
   if (viewMode === 'unit-side') return `unit-diagram-svg-${unitIndex}`;
   if (viewMode === 'combo-top') return `combo-top-svg-${unitIndex}`;
   if (viewMode === 'combo-side') return `combo-side-svg-${unitIndex}`;
   throw new Error(`Unknown view mode: ${viewMode}`);
}

function getView(viewMode) {
   if (viewMode === 'unit-side') return 'side';
   if (viewMode === 'combo-top') return 'top';
   if (viewMode === 'combo-side') return 'side';
   throw new Error(`Unknown view mode: ${viewMode}`);
}

function minMaxXBounds(units) {
   let min = Infinity;
   let max = -Infinity;
   let totalXLength = 0;

   for (const unit of units) {
      let unitMin = 0;
      let unitMax = 0;

      switch (unit.unitType) {
         case 'dog-trailer':
            unitMin = 0;
            unitMax =
               (Number(unit.drawbarLength) || 0) - (Number(unit.forwardOverhang) || 0) + (Number(unit.bodyLength) || 0);
            break;
         case 'semi-trailer':
            unitMin = -(Number(unit.forwardOverhang) || 0);
            unitMax = (Number(unit.bodyLength) || 0) - (Number(unit.forwardOverhang) || 0);
            break;
         case 'lead-semi-trailer':
            unitMin = -(Number(unit.forwardOverhang) || 0);
            const rearOverhang = (Number(unit.turntableRearClearance) || 0) + 1.1;
            unitMax = (Number(unit.bodyLength) || 0) - (Number(unit.forwardOverhang) || 0) + rearOverhang;
            break;
         default:
            unitMin = 0;
            unitMax = Number(unit.bodyLength) || 0;
      }

      min = Math.min(min, unitMin);
      max = Math.max(max, unitMax);
      totalXLength += unitMax - unitMin;
   }

   return { min, max, totalXLength };
}

function maxWidthHeight(units) {
   let maxBodyHeight = 2;
   let maxBodyWidth = 1;
   for (const unit of units) {
      const { cabGHeight, bodyGHeight, cargoGHeight, bodyWidth } = unit;
      const unitMaxY = Math.max(Number(cabGHeight) || 0, Number(bodyGHeight) || 0, Number(cargoGHeight) || 0);
      maxBodyHeight = Math.max(maxBodyHeight, unitMaxY);
      const unitWidth = Number(bodyWidth) || 0;
      maxBodyWidth = Math.max(maxBodyWidth, unitWidth);
   }
   return { maxBodyHeight, maxBodyWidth };
}
